var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSta3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 59,
    viewBox: "0 0 56 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_704_6736)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6792 13.5889L12.2119 28.8979C9.76958 27.1778 -1.22108 15.653 7.67612 2.5801L8.19948 1.72005L9.07176 1.20401C10.4674 0.343952 13.4331 0.17194 15.3521 1.032C12.5609 5.5043 13.782 7.39643 16.7478 9.11655L23.2026 12.7288L22.6792 13.5889ZM9.94403 7.05241C10.4674 9.11655 11.863 10.8367 14.1309 12.2128L18.3179 14.6209L12.3864 23.2215C8.37394 17.8891 7.50166 12.7288 9.94403 7.05241Z",
    fill: "#BC7800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5529 22.7055L30.3535 39.3906C32.9703 40.5947 48.6713 44.207 55.6495 30.102L56.1728 29.242V28.2099C56.1728 26.4898 54.9516 23.9096 53.2071 22.7055C50.7647 27.1778 48.4968 27.1778 45.3566 25.4577L38.9018 21.8455L38.5529 22.7055ZM50.5903 30.274C48.4968 30.7901 46.2289 30.446 43.961 29.242L39.7741 26.8338L35.0638 36.1224C41.8675 36.9825 46.9267 35.0904 50.5903 30.274Z",
    fill: "#BC7800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6792 13.5888L12.2119 28.8979C9.76958 27.1778 -1.22108 15.653 7.67612 2.58009L8.19948 1.72003C9.76958 1.204 11.863 1.03198 13.782 2.06405C12.0375 5.16026 12.7353 7.91245 15.8755 9.63257L22.6792 13.5888ZM18.3179 14.6209L14.1309 12.2127C10.9908 10.4926 9.59512 7.91245 9.76958 4.98825C6.9783 9.46056 6.62939 14.2769 8.54839 19.0932C9.24621 20.9853 10.4674 22.7055 11.6886 24.2536L18.3179 14.6209Z",
    fill: "url(#paint0_linear_704_6736)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6775 13.5888L23.2008 12.7288L16.746 9.11653C13.7803 7.39641 12.5591 5.50429 15.3504 1.03198L13.7803 2.06405C12.0357 5.16026 12.7336 7.91245 15.8737 9.63257L22.6775 13.5888Z",
    fill: "url(#paint1_linear_704_6736)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94237 7.05242C9.76791 6.36437 9.76791 5.67633 9.76791 4.98828C6.97663 9.46058 6.62772 14.2769 8.54673 19.0932C9.24455 20.9854 10.4657 22.7055 11.6869 24.4256L12.3847 23.3935C8.37227 17.8892 7.5 12.7288 9.94237 7.05242Z",
    fill: "url(#paint2_linear_704_6736)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19922 1.89203C9.76931 1.37599 11.8628 1.20398 13.7818 2.23605L15.3519 1.20398C13.4329 0.171911 10.6416 0.515934 9.07149 1.37599L8.19922 1.89203Z",
    fill: "url(#paint3_linear_704_6736)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5529 22.7054L30.3535 39.3906C32.9703 40.5947 48.6713 44.2069 55.6495 30.1019L56.1728 29.2419C55.8239 27.6938 54.9516 25.8017 53.2071 24.5976C51.4626 27.5218 48.6713 28.3818 45.5311 26.6617L38.5529 22.7054ZM39.7741 26.8337L43.961 29.2419C47.1012 30.962 50.0669 30.962 52.5093 29.4139C49.8925 34.0582 45.88 36.8104 40.6464 37.4984C38.5529 37.8425 36.4594 37.6705 34.5404 37.4984L39.7741 26.8337Z",
    fill: "url(#paint4_linear_704_6736)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5547 22.7055L38.9036 21.8455L45.3584 25.4577C48.3242 27.1778 50.5921 27.1778 53.2089 22.7055V24.5976C51.4643 27.5218 48.6731 28.3819 45.5329 26.6618L38.5547 22.7055Z",
    fill: "url(#paint5_linear_704_6736)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5915 30.274C51.2893 30.102 51.9871 29.758 52.5105 29.4139C49.8937 34.0583 45.8812 36.8104 40.6476 37.4985C38.5541 37.8425 36.4606 37.6705 34.3672 37.4985L34.8906 36.2944C41.8687 36.9825 46.9279 35.0903 50.5915 30.274Z",
    fill: "url(#paint6_linear_704_6736)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8531 54.8716L20.9341 58.3118C19.8874 60.032 14.4793 58.6559 8.7223 55.3876C2.96529 52.1194 -0.872713 48.1632 0.174016 46.443L2.09302 43.0028L22.8531 54.8716Z",
    fill: "url(#paint7_linear_704_6736)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8525 54.8717C21.8058 56.5918 16.3977 55.2158 10.6406 51.9475C5.05809 48.6793 1.22009 44.723 2.09236 43.0029C3.83691 39.9067 6.9771 40.7668 10.6406 41.1108C12.3852 41.2828 13.9553 40.9388 14.8276 39.2187L15.8743 37.3265L18.3167 38.7026L20.759 40.0787L19.7123 41.9709C18.84 43.519 19.3634 45.0671 20.2357 46.4432C22.3291 49.7114 24.7715 51.7755 22.8525 54.8717Z",
    fill: "url(#paint8_linear_704_6736)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14036 43.691C4.88491 40.5947 7.67619 41.2828 11.1653 41.4548C12.7354 41.4548 14.131 41.1108 15.1777 39.5627C15.5267 38.8746 15.8756 38.3586 16.2245 37.6705L16.05 37.4985L15.0033 39.3907C14.131 40.9388 12.3865 41.2828 10.8164 41.2828C6.97837 40.9388 4.01264 39.9067 2.09363 43.0029C1.74472 43.5189 1.91918 44.207 2.44254 45.0671C2.617 44.551 2.96591 44.035 3.14036 43.691Z",
    fill: "url(#paint9_radial_704_6736)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5376 46.099C21.1077 48.8512 23.0267 50.7433 21.2821 53.8396C20.9332 54.3556 20.5843 54.8716 20.4098 55.3877C21.631 55.5597 22.6778 55.2157 23.0267 54.6996C24.7712 51.6034 22.5033 49.5393 20.4098 46.4431C19.5376 45.067 19.0142 43.5189 19.8865 41.9708L20.9332 40.0786L20.5843 39.9066C20.2354 40.5947 19.8865 41.1107 19.5376 41.7987C18.4908 43.5189 18.8398 44.895 19.5376 46.099Z",
    fill: "url(#paint10_radial_704_6736)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.888 53.1516C21.6326 50.0553 20.0625 48.3352 18.8413 45.7551C18.3179 44.551 18.1435 43.1749 19.0157 41.6268C19.3647 40.9387 19.7136 40.4227 20.0625 39.7346L19.3647 39.3906C19.0157 40.0787 18.6668 40.5947 18.3179 41.2828C17.4456 42.8309 17.2712 44.0349 17.4456 45.067C17.7946 47.1312 18.6668 48.5072 16.7478 51.6035C16.2245 52.4635 15.7011 53.4956 15.1777 54.3556C16.3989 54.8717 17.4456 55.2157 18.4924 55.3877C19.1902 54.5277 19.5391 53.8396 19.888 53.1516Z",
    fill: "url(#paint11_radial_704_6736)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4673 47.8192C12.2119 44.723 13.2586 44.379 14.6542 43.3469C15.3521 42.8309 16.0499 41.9708 16.9221 40.4227C17.2711 39.7347 17.62 39.2186 17.9689 38.5306L16.9221 37.8425C16.5732 38.5306 16.2243 39.0466 15.8754 39.7347C15.0031 41.2828 13.782 41.9708 12.5608 42.1428C9.94396 42.6589 8.02495 42.3148 6.2804 45.411C5.75704 46.2711 5.40813 46.9591 4.88477 47.8192C5.93149 48.8513 7.15268 49.7113 8.72277 50.7434C9.24614 49.7113 9.7695 48.6793 10.4673 47.8192Z",
    fill: "url(#paint12_radial_704_6736)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09271 43.0028L0.173711 46.443C-0.175199 46.9591 -0.000743879 47.6471 0.522621 48.5072L2.44162 45.0669C1.91826 44.2069 1.7438 43.5188 2.09271 43.0028Z",
    fill: "url(#paint13_linear_704_6736)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4112 55.5598L18.4922 59C19.7134 59.172 20.7601 58.828 21.109 58.3119L23.028 54.8717C22.5046 55.3877 21.6324 55.7318 20.4112 55.5598Z",
    fill: "url(#paint14_linear_704_6736)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5529 22.7054L30.3535 39.3906C31.0513 39.7346 32.6214 40.0786 34.5404 40.4226C36.285 39.7346 38.0295 38.7025 39.5996 37.4984C38.0295 37.6705 36.285 37.4984 34.7149 37.3264L39.9485 26.8337L44.1354 29.2419C45.3566 29.9299 46.4034 30.274 47.4501 30.446C47.6245 30.274 47.799 30.1019 47.9735 29.7579L50.0669 27.1777C48.6713 27.6938 47.1012 27.5218 45.3566 26.4897L38.5529 22.7054Z",
    fill: "url(#paint15_radial_704_6736)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0606 41.6267C19.8862 41.9707 18.665 41.6267 17.2694 40.7667C16.0482 39.9066 15.1759 38.7025 15.3504 38.3585L16.0482 37.1544L20.7585 40.4226L20.0606 41.6267Z",
    fill: "url(#paint16_radial_704_6736)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7475 6.19238L32.2739 15.137L47.8004 24.0816L44.6602 28.0379C38.5543 35.9504 27.0403 45.239 17.6197 39.9067C8.19918 34.5743 10.6415 20.1253 14.4796 10.8367L16.7475 6.19238Z",
    fill: "url(#paint17_linear_704_6736)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2699 6.53638L29.8307 13.7609L42.3914 20.9854L39.7746 24.5976C34.7154 31.6501 25.1204 40.0787 17.4444 35.6063C9.9428 31.3061 12.2107 18.7492 15.5254 10.6647L17.2699 6.53638Z",
    fill: "url(#paint18_radial_704_6736)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3174 7.22449L27.9124 12.5568L37.5074 18.0612L35.414 21.1574C31.2271 27.1778 23.3766 34.4023 17.4451 31.1341C11.6881 27.8659 13.7816 17.3732 16.7473 10.6647L18.3174 7.22449Z",
    fill: "url(#paint19_radial_704_6736)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7936 39.9067C9.41974 35.0903 12.211 20.9854 16.2235 11.8688C16.9213 10.3207 17.6191 8.77256 18.3169 7.22445L16.7468 6.19238L14.6534 10.8367C10.8154 20.1253 8.37301 34.5743 17.7936 39.9067Z",
    fill: "url(#paint20_radial_704_6736)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7406 26.8337C36.8092 34.9183 25.8185 44.5509 17.6191 39.9066C27.0397 45.239 38.5537 35.9503 44.6596 28.0378L47.7998 24.0815L45.7064 22.8774C44.8341 24.2535 43.7874 25.6296 42.7406 26.8337Z",
    fill: "url(#paint21_radial_704_6736)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.6
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.793 39.9067C24.5967 43.6909 34.7151 33.7143 40.4721 25.6297C41.5188 24.2536 42.3911 22.8775 43.4378 21.5014L39.0765 18.9213C38.2042 20.2974 37.1575 21.6735 36.2852 23.0495C30.7026 31.4781 21.8054 42.3149 17.793 39.9067Z",
    fill: "url(#paint22_radial_704_6736)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7942 39.9066C15.8752 38.8746 21.9811 26.4897 26.6914 17.7171C27.5637 16.169 28.2615 14.7929 29.1338 13.2448L22.8534 9.63257C22.1556 11.1807 21.4578 12.5568 20.5855 14.1049C16.3986 23.2215 12.2116 36.8104 17.7942 39.9066Z",
    fill: "url(#paint23_radial_704_6736)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.483 19.9533C22.1558 15.825 16.7478 10.6646 16.2244 7.56841C15.8755 5.84829 17.9689 2.75208 18.8412 1.20398L35.0655 10.4926L51.2898 19.7812C50.4175 21.3293 48.673 24.7696 47.1029 25.2856C43.9627 26.3177 36.8101 24.2535 29.483 19.9533Z",
    fill: "url(#paint24_radial_704_6736)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.913 18.5772C21.8071 14.7929 17.4457 10.3206 16.9223 7.56845C16.7479 6.19235 18.4924 3.61218 19.1903 2.23608L32.4488 10.4926L45.7074 18.7492C44.8351 20.1253 43.4395 22.8775 42.2183 23.3935C39.7759 24.2536 34.0189 22.3614 27.913 18.5772Z",
    fill: "url(#paint25_radial_704_6736)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1668 16.6851C21.4565 13.4169 17.9674 9.63262 17.6185 7.56848C17.444 6.3644 18.8397 4.30026 19.5375 3.26819L30.0048 10.3207L40.4721 17.3731C39.7742 18.4052 38.7275 20.6414 37.6808 20.9854C35.5873 21.6734 31.0515 19.9533 26.1668 16.6851Z",
    fill: "url(#paint26_radial_704_6736)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.288 19.7812C50.7647 20.8133 49.0201 21.1573 46.9267 20.9853L45.7055 22.8775L43.9609 25.4576C45.1821 25.6296 46.2288 25.4576 47.1011 25.2856C48.6712 24.5976 50.2413 21.3294 51.288 19.7812Z",
    fill: "url(#paint27_radial_704_6736)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4923 7.39651L19.7135 5.16036C18.6668 3.61225 18.3178 2.23616 18.8412 1.3761C17.9689 2.9242 15.8755 6.02041 16.2244 7.56852C16.2244 7.91254 16.3988 8.25656 16.5733 8.60059C16.7477 8.94461 16.9222 9.46065 17.2711 9.80467L18.4923 7.39651Z",
    fill: "url(#paint28_radial_704_6736)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.65
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7282 18.7493L36.1113 23.2216C37.3325 23.7376 38.7281 24.2536 39.7749 24.5977C40.1238 24.7697 40.4727 24.7697 40.9961 24.9417L43.0895 21.3294L43.6129 20.2974C42.2172 19.9534 40.6472 19.4373 38.7282 18.7493Z",
    fill: "url(#paint29_radial_704_6736)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.133 13.5889C27.0395 12.2128 25.1205 10.8367 23.5504 9.46057L20.9336 13.9329C22.5037 15.309 24.4227 16.6851 26.5161 18.2332L29.133 13.5889Z",
    fill: "url(#paint30_radial_704_6736)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8553 5.67628C46.7525 10.6646 52.5096 17.0291 50.9395 19.7812C49.3694 22.5334 40.8211 20.8133 31.9239 15.653C23.0267 10.6646 17.2697 4.30019 18.8398 1.548C20.4099 -1.20419 28.9582 0.515932 37.8553 5.67628Z",
    fill: "#FFFCE4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8553 5.50432C46.7525 10.6647 52.8584 17.0291 51.1139 19.6093C49.5438 22.3615 40.9955 20.4693 31.9239 15.309C23.0267 10.1486 16.9207 3.78421 18.6653 1.20403C20.4098 -1.54815 28.9581 0.515985 37.8553 5.50432Z",
    fill: "url(#paint31_radial_704_6736)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6818 5.84831C46.0556 10.6646 51.8126 16.513 50.2425 18.9212C48.8469 21.3294 40.8219 19.4372 32.4481 14.6209C24.0743 9.80458 18.3173 3.95618 19.8874 1.54802C21.283 -0.860143 29.3079 1.03199 37.6818 5.84831Z",
    fill: "url(#paint32_radial_704_6736)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8907 4.8163C41.1711 8.42855 45.358 13.0729 46.0558 16.6851C46.2302 17.7172 46.2302 18.7492 45.7069 19.6093C45.7069 19.6093 45.7069 19.7813 45.5324 19.7813C47.8003 20.1253 49.5449 19.9533 50.2427 18.9213C50.2427 18.9213 50.2427 18.7492 50.4172 18.7492C51.8128 16.3411 46.2302 10.4927 37.8564 5.67636C30.8782 1.72009 24.0745 -0.344046 21.2832 0.516012C24.7723 0.516012 29.8315 2.06412 34.8907 4.8163Z",
    fill: "url(#paint33_radial_704_6736)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4266 18.0611C39.7755 16.169 38.3799 13.4168 35.7631 10.8367C34.0185 9.11654 31.7506 7.39642 29.1338 5.84831C26.517 4.30021 23.9001 3.26814 21.4578 2.7521C20.9344 2.58009 20.2366 2.40808 19.7132 2.40808C19.3643 5.16027 24.7724 10.3206 32.4484 14.7929C34.8908 16.169 37.1587 17.2011 39.4266 18.0611Z",
    fill: "url(#paint34_radial_704_6736)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89617 44.0349C10.4663 45.239 11.513 46.6151 11.1641 47.3031C10.8152 47.9912 9.24508 47.4752 7.67499 46.4431C6.1049 45.239 5.05817 43.8629 5.40708 43.1749C5.75599 42.4868 7.32608 43.0028 8.89617 44.0349Z",
    fill: "url(#paint35_radial_704_6736)"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54676 3.09615C9.41903 2.23609 12.2103 2.75212 12.5592 3.61218C12.7337 4.12822 12.3848 5.3323 13.0826 6.53638C12.5592 5.3323 12.9081 3.78419 13.7804 2.06408C11.8614 1.20402 9.76794 1.37603 8.19785 1.89207L7.67449 2.58011C4.88321 6.53638 4.01093 10.4926 4.18539 13.9329C4.35984 9.63259 6.97667 4.47224 8.54676 3.09615Z",
    fill: "url(#paint36_radial_704_6736)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9096 1.37603C11.165 1.20402 10.1183 1.37603 8.72266 1.72006C10.1183 1.37603 12.0373 1.37603 13.7818 2.23609L15.3519 1.20402C15.003 0.86 14.4797 0.687988 13.7818 0.687988C13.9563 0.86 14.1308 1.20402 13.9563 1.20402C13.6074 1.37603 13.084 1.37603 12.9096 1.37603Z",
    fill: "url(#paint37_radial_704_6736)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1635 21.5014C11.1635 21.8454 10.9891 22.3615 10.4657 21.8454C7.5 19.4373 6.80218 13.0728 7.84891 9.6326C8.02336 9.28857 8.37227 8.08449 8.72118 8.2565C8.89564 8.42851 9.07009 8.77254 9.07009 9.11656C9.24455 8.42851 9.59346 7.74047 9.76791 7.05242C9.76791 6.36437 9.76791 5.67633 9.76791 4.98828C6.97663 9.46058 6.62772 14.2769 8.54673 19.0932C9.07009 20.4693 9.76791 21.6734 10.6402 22.8775C10.8146 23.2215 11.1635 23.5655 11.338 23.9096C11.338 23.2215 11.5125 22.7055 11.5125 22.0174C11.5125 21.8454 11.338 21.6734 11.1635 21.5014Z",
    fill: "url(#paint38_radial_704_6736)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3324 36.2944C36.9835 36.4664 36.6345 36.8104 37.3324 36.9825C40.9959 38.3585 46.9274 35.7784 49.3697 33.1982C49.5442 33.0262 50.4165 31.9941 50.0676 31.8221C49.8931 31.6501 49.5442 31.8221 49.1953 31.9941C49.7187 31.4781 50.242 30.962 50.5909 30.274C51.2888 30.102 51.9866 29.758 52.5099 29.4139C49.8931 34.0583 45.8807 36.8104 40.647 37.4985C39.2514 37.6705 37.6813 37.6705 36.2856 37.6705C35.9367 37.6705 35.4134 37.6705 35.0645 37.4985C35.5878 37.1545 36.1112 36.8104 36.6345 36.4664C36.809 36.2944 37.1579 36.2944 37.3324 36.2944Z",
    fill: "url(#paint39_radial_704_6736)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.451 26.3178C47.102 26.3178 46.7531 26.1458 46.4042 25.9738L45.8809 26.8338C47.451 27.5219 48.8466 27.6939 50.0678 27.1778C49.7189 27.3498 47.451 27.3498 47.2765 26.6618C47.2765 26.4898 47.2765 26.4898 47.451 26.3178Z",
    fill: "url(#paint40_linear_704_6736)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8272 7.7405C15.1761 8.08453 15.3506 8.25654 15.6995 8.42855L15.3506 9.46062C13.9549 8.42855 13.0827 7.39648 12.9082 6.02039C12.9082 6.36441 14.1294 8.25654 14.6528 8.08453C14.8272 8.08453 14.8272 7.91251 14.8272 7.7405Z",
    fill: "url(#paint41_linear_704_6736)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_6736",
    x1: 5.48008,
    y1: 0.35185,
    x2: 18.5107,
    y2: 26.0057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_704_6736",
    x1: 16.8699,
    y1: 0.968682,
    x2: 18.0056,
    y2: 9.46035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB7D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_704_6736",
    x1: 7.82588,
    y1: 5.28586,
    x2: 10.8127,
    y2: 23.8476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#CC8B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_704_6736",
    x1: 8.22539,
    y1: 1.36292,
    x2: 15.3896,
    y2: 1.36292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_704_6736",
    x1: 29.8923,
    y1: 34.6375,
    x2: 81.673,
    y2: 18.6007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B35100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_704_6736",
    x1: 45.013,
    y1: 24.2502,
    x2: 52.2954,
    y2: 21.1948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B86800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_704_6736",
    x1: 35.1336,
    y1: 38.357,
    x2: 52.7917,
    y2: 30.3338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C75A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#BF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_704_6736",
    x1: 0.246414,
    y1: 46.2323,
    x2: 20.8846,
    y2: 58.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00743494,
    stopColor: "#781916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#963333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#450E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_704_6736",
    x1: 4.21024,
    y1: 39.4622,
    x2: 24.8484,
    y2: 51.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520446,
    stopColor: "#ED9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9257,
    stopColor: "#B36600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.82465 47.0976) scale(13.425 13.237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3754 54.1177) scale(14.03 13.8335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3219 48.5717) scale(9.69131 9.55559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.73065 42.7753) scale(9.69428 9.55852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_704_6736",
    x1: 0.737026,
    y1: 45.3939,
    x2: 1.82326,
    y2: 46.0301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6029,
    stopColor: "#C3C7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_704_6736",
    x1: 19.8481,
    y1: 56.447,
    x2: 21.4357,
    y2: 57.3767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3971,
    stopColor: "#C3C7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616DBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6952 23.3178) scale(19.0878 18.8205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5566 37.7568) scale(8.22467 8.10949)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#FFA163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_704_6736",
    x1: 9.43415,
    y1: 18.6694,
    x2: 40.4265,
    y2: 36.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520446,
    stopColor: "#ED9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D96D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3137 11.4829) scale(29.7829 29.3658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4311 8.67627) scale(23.7485 23.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4609 22.3367) scale(25.0575 24.7066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9317 24.6402) scale(21.6641 21.3608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4041 12.6585) scale(28.4395 28.0412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1492 10.8293) scale(29.9846 29.5647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2747 12.258) scale(29.4754 29.0626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9932 -3.56312) scale(28.7578 28.3551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8421 1.22727) scale(20.3591 20.0739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2197 18.8699) scale(12.2642 12.0924)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA163"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6482 9.23875) scale(12.5276 12.3522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA163"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8088 16.0368) scale(11.6248 11.462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6697 8.24686) scale(15.3534 15.1384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6264 7.38785) scale(42.795 42.1957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5114 2.61157) scale(22.2634 21.9516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8418 19.3358) scale(28.4379 28.0396)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#211F0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#746E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9707,
    stopColor: "#F7EB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF369"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3061 19.1902) scale(25.2987 24.9444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.36586 42.0224) scale(8.42687 8.30885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.71204 -1.39559) scale(18.7453 18.4828)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6847 -0.566664) scale(6.5213 6.42997)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077724,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2193,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3612,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5001,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7659,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF369"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9565 14.377) scale(12.5133 12.3381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_704_6736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6008 25.3777) scale(16.782 16.547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_704_6736",
    x1: 45.8135,
    y1: 26.7117,
    x2: 49.9652,
    y2: 26.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_704_6736",
    x1: 15.7651,
    y1: 9.60459,
    x2: 13.001,
    y2: 5.83461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E08F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_704_6736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 59,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSta3);
export default __webpack_public_path__ + "static/media/sta_3.34bc76d06f4d270e3d21ad0947bf62cd.svg";
export { ForwardRef as ReactComponent };